<template>
  <BaseAlert type="info" alignment="left">
    <template #message>
      <div :class="$style.instructions">
        <!--
          complaintForm.ticket.explanation_video_text.engine	
          complaintForm.ticket.explanation_video_text.components	
          complaintForm.ticket.explanation_video_text.buyEngine	
        -->
        {{ $t(`complaintForm.ticket.explanation_video_text.${tutorialTranslationType}`) }}
        <BaseButton
          :href="$t(`complaintForm.ticket.explanation_video_link.${tutorialTranslationType}`)"
          target="_blank"
          >{{ $t('complaintForm.ticket.explanation_video_link_text') }}</BaseButton
        >
        <!--
        complaintForm.ticket.explanation_video_link.engine	
        complaintForm.ticket.explanation_video_link.components	
        complaintForm.ticket.explanation_video_link.buyEngine	
        -->
      </div>
    </template>
  </BaseAlert>
</template>

<script>
export default {
  name: 'ComplaintFormTutorialInfoBox',
  props: {
    tutorialTranslationType: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" module>
.instructions {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    grid-template-columns: 1fr 1fr;

    align-items: center;
    margin: unset;
    place-items: center start;
  }
  display: grid;
  place-items: center;

  gap: 1rem;
  margin: auto;
}
</style>
